import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import awsconfig from './aws-exports';
import './index.css';
import App from './App';
import { useAppStore } from './stores/useAppStore';
import reportWebVitals from './reportWebVitals';

// Pick the redirect URL that matches the current platform/origin.
const isCapacitor = typeof window !== 'undefined' && window.location.protocol === 'capacitor:';
const webOrigin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';

const redirectSignIn = isCapacitor ? 'capacitor://localhost/auth/callback' : `${webOrigin}/auth/callback`;
const redirectSignOut = isCapacitor ? 'capacitor://localhost/login' : `${webOrigin}/login`;

Amplify.configure({
  ...awsconfig,
  oauth: {
    ...awsconfig.oauth,
    redirectSignIn,
    redirectSignOut,
  },
});

// Apply dark mode class before render — prevents FOUC.
const initialNight = useAppStore.getState().nightMode;
document.documentElement.classList.toggle('dark', initialNight);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 120000, retry: 1, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="top-center"
        containerStyle={{ top: 'env(safe-area-inset-top, 8px)' }}
        toastOptions={{ duration: 3000, style: { borderRadius: '8px', fontSize: '14px' } }}
      />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
